import { render } from "./HomeSlides.vue?vue&type=template&id=dc76fd90"
import script from "./HomeSlides.vue?vue&type=script&lang=js"
export * from "./HomeSlides.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__